import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import { Col } from 'react-bootstrap';
import CircledIcon from '../../CompositeIcons/CircledIcon';
import {TOGGLE_SIDEBAR_COLLAPSED} from "../../../Redux/Actions/Types/appStatusTypes";

const CollapsibleSidebar = props => {
    const {
        code,
    } = props;
    
    const dispatch = useDispatch();
    const hide = useSelector(state => state.appStatusState.sidebarCollapsed?.[code] ?? false);
    
    const classNameFromCode = code ? `${code}-sidebar` : '';
    
    return (
        <Col xs={3} className={`streambank-sidebar collapsible-sidebar ${classNameFromCode} ${hide ? 'hide' : 'show'}`}>
            <CircledIcon
                icon={['fal', 'angle-right']}
                circleSize="10"
                iconTransform="grow-2 right-1"
                className="btn-collapse"
                onClick={() => dispatch({type: TOGGLE_SIDEBAR_COLLAPSED, code: code})}
            />
            <div className="content">
                {props.children}
            </div>
        </Col>
    )
};

export default CollapsibleSidebar;
